import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Modal, Button } from "react-bootstrap";
import Image from "components/Image";
import Icon from "components/Icon";

const TimelineDetailDialog = ({
  onHide,
  logo,
  companyName,
  positionName,
  jobDesc,
  smallDesc,
  show,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="">
        <Header>
          <Image className="image-logo" fileName={logo} alt={companyName} />
          <WrwpperTitle>
            <Modal.Title className="item-intro ">{positionName}</Modal.Title>
            <p className="item-intro">{companyName}</p>
          </WrwpperTitle>
        </Header>

        <ul className="mt-3">
          {smallDesc.map((x) => (
            <li key={x}>{x}</li>
          ))}
        </ul>
        {/* <p>{jobDesc}</p> */}
        {/* {jobDesc} */}
      </Modal.Body>
      <Modal.Footer>
        <div className="mx-auto">
          <Button variant="primary" onClick={onHide}>
            Close &nbsp;
            <Icon iconName="CloseIcon" />
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

TimelineDetailDialog.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  logo: PropTypes.string,
  positionName: PropTypes.string,
  companyName: PropTypes.string,
  smallDesc: PropTypes.array,
  jobDesc: PropTypes.any,
};

TimelineDetailDialog.defaultProps = {
  onHide: null,
  show: false,
  logo: "",
  positionName: "",
  companyName: "",
  smallDesc: [],
  jobDesc: null,
};

export default TimelineDetailDialog;

const Header = styled.div`
  display: flex;
  align-items: center;
`;

const WrwpperTitle = styled.div`
  display: flex;
  margin-left: 10px;
  flex-direction: column;
`;
